import { handleActions } from 'redux-actions';
import { defaultBlockedUsernamesWidgetState } from './defaults';
import { BlockedUsernamesWidgetData } from './types';
import { initSecurityPage } from '../../actions';
import {
  INITIAL_SAVE_REQUEST_META,
  makeSpecificSaveableWidgetDataMergeFunction,
  saveableWidgetRequestMetaReducer,
} from '../utils';
import {
  saveBlockedUsernames,
  saveBlockedUsernamesFailure,
  saveBlockedUsernamesSuccess,
  setBlockedUsernamesWidgetBlockedUsers,
} from './actions';

const mergeBlockedUsernamesWidgetDataChange = makeSpecificSaveableWidgetDataMergeFunction(
  defaultBlockedUsernamesWidgetState
);

export default handleActions<BlockedUsernamesWidgetData, any>(
  {
    [initSecurityPage.toString()]: (state, action: ReturnType<typeof initSecurityPage>) => {
      const blockedUsers = action.payload.data.blockedUsers
        .map(user => ({ username: user.username, isBanned: user.isBanned }))
        .sort((a, b) => a.username.localeCompare(b.username));
      const data: BlockedUsernamesWidgetData['initialData'] = { blockedUsers };
      return {
        initialData: data,
        currentData: data,
        isDirty: false,
        saveRequest: INITIAL_SAVE_REQUEST_META,
      };
    },
    [setBlockedUsernamesWidgetBlockedUsers.toString()]: (
      state,
      action: ReturnType<typeof setBlockedUsernamesWidgetBlockedUsers>
    ) =>
      mergeBlockedUsernamesWidgetDataChange(state, {
        blockedUsers: action.payload.blockedUsers,
      }),
    ...saveableWidgetRequestMetaReducer({
      initialAction: saveBlockedUsernames,
      successAction: saveBlockedUsernamesSuccess,
      failureAction: saveBlockedUsernamesFailure,
    }),
  },
  defaultBlockedUsernamesWidgetState
);
